export const created = [
  {
    Header: 'Solicitation Number',
    accessor: 'solNum',
  },
  {
    Header: 'NSN',
    accessor: 'nsn',
  },
  {
    Header: 'Solicitation Create Date',
    accessor: 'solCreateDate',
  },

  {
    Header: 'Solicitation Close Date',
    accessor: 'solCloseDate',
  },

  {
    Header: 'Quote Create Date',
    accessor: 'dqCreateDate',
  },
  {
    Header: 'Last Modified',
    accessor: 'lastModified',
  },
  {
    Header: 'Modified By',
    accessor: 'email',
  },
  {
    Header: 'Solicitation Status',
    accessor: 'solStatus',
  },
  {
    Header: 'Quote Status',
    accessor: 'status',
  },
];

export const submitted = [
  {
    Header: 'Solicitation Number',
    accessor: 'solNum',
  },
  {
    Header: 'NSN',
    accessor: 'nsn',
  },
  {
    Header: 'Solicitation Create Date',
    accessor: 'solCreateDate',
  },

  {
    Header: 'Solicitation Close Date',
    accessor: 'solCloseDate',
  },

  {
    Header: 'Quote Create Date',
    accessor: 'dqCreateDate',
  },
  {
    Header: 'Last Modified',
    accessor: 'lastModified',
  },
  {
    Header: 'Modified By',
    accessor: 'email',
  },
  {
    Header: 'Solicitation Status',
    accessor: 'solStatus',
  },
  {
    Header: 'Quote Status',
    accessor: 'status',
  },

  {
    Header: 'Total Value',
    accessor: 'totalValue',
  },
];

export const awarded = [
  {
    Header: 'Solicitation Number',
    accessor: 'solNum',
  },
  {
    Header: 'NSN',
    accessor: 'nsn',
  },
  {
    Header: 'Solicitation Create Date',
    accessor: 'solCreateDate',
  },

  {
    Header: 'Solicitation Close Date',
    accessor: 'solCloseDate',
  },

  {
    Header: 'Quote Create Date',
    accessor: 'dqCreateDate',
  },
  {
    Header: 'Last Modified',
    accessor: 'lastModified',
  },
  {
    Header: 'Modified By',
    accessor: 'email',
  },
  {
    Header: 'Solicitation Status',
    accessor: 'solStatus',
  },
  {
    Header: 'Quote Status',
    accessor: 'status',
  },

  {
    Header: 'Total Value',
    accessor: 'totalValue',
  },
];

export const archived = [
  {
    Header: 'Solicitation Number',
    accessor: 'solNum',
  },
  {
    Header: 'NSN',
    accessor: 'nsn',
  },
  {
    Header: 'Solicitation Create Date',
    accessor: 'solCreateDate',
  },

  {
    Header: 'Solicitation Close Date',
    accessor: 'solCloseDate',
  },

  {
    Header: 'Quote Create Date',
    accessor: 'dqCreateDate',
  },
  {
    Header: 'Last Modified',
    accessor: 'lastModified',
  },
  {
    Header: 'Modified By',
    accessor: 'email',
  },
  {
    Header: 'Solicitation Status',
    accessor: 'solStatus',
  },
  {
    Header: 'Quote Status',
    accessor: 'status',
  },

  {
    Header: 'Total Value',
    accessor: 'totalValue',
  },
];



// WEBPACK FOOTER //
// ./src/pages/ContractCenter/ColumnGrids/DibbsColumns.jsx